export default __webpack_public_path__ + "static/media/mobility_endorsed.950e0d7f.svg";